module.exports = __webpack_public_path__ + "img/platform_smd.704030da.png";